import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StandardFormBuilderComponent } from './standard-form-builder/standard-form-builder.component';
import { StandardFormPanelComponent } from './standard-form-panel/standard-form-panel.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ExpressionBuilderComponent } from './expression-builder/expression-builder.component';
import { StandardGroupFormBuilderComponent } from './standard-group-form-builder/standard-group-form-builder.component';
import { ExtractFormValuePipe } from './extract-form-value.pipe';
import { FileuploadFormBuilderComponent } from './fileupload-form-builder/fileupload-form-builder.component';
import { DragDropModule } from 'primeng/dragdrop';
import { FileUploadModule } from 'primeng/fileupload';
import { FilterInvisiblePipe } from './filter-invisible.pipe';
import { SelectItemGroupDataPrepPipe } from './selectitemgroup-data-prep.pipe';
import { OnecolumnFormBulderComponent } from './onecolumn-form-bulder/onecolumn-form-bulder.component';
import { FormParamValueComponent } from './form-elements/form-param-value/form-param-value.component';
import { SharedModule } from '../../../../src/app/shared/shared.module';
import { CalendarModule } from 'primeng/calendar';
import { IconPicklistFormComponent } from './icon-picklist-form/icon-picklist-form.component';
import { SeparatedBtnFormPanelComponent } from './separated-btn-form-panel/separated-btn-form-panel.component';
import { SimpleFormBuilderComponent } from './simple-form-builder/simple-form-builder.component';
import { FormExpressionViewerComponent } from './form-expression-viewer/form-expression-viewer.component';
import { ParsedExpressionBlockComponent } from './form-expression-viewer/parsed-expression-block/parsed-expression-block.component';
import { MaxCharsPipe } from './max-chars.pipe';
import {ModernFormBuilderComponent} from './modern-form-builder/modern-form-builder.component';
import { ModernFormPanelComponent } from './modern-form-panel/modern-form-panel.component';
import { AttributesListComponent } from './attributes-list/attributes-list.component';
import {RuleactionFormBuilderComponent} from './ruleaction-form-builder/ruleaction-form-builder.component';
import {PipesModule} from '../../../../src/app/shared/pipes/pipes.module';
import {TreeTableModule} from 'primeng/treetable';
import {SvgNodeComponent} from './svg-node-component/svg-node.component';
import {DropdownModule} from 'primeng/dropdown';
import {RadioButtonModule} from 'primeng/radiobutton';
import {InsparkComponentsModule} from '@inspark/inspark-components';
import {
    InsparkOverlayHlsVideoModule
} from '../inspark-overlay-hls-video/inspark-overlay-hls-video.module';

import {InlineSVGModule} from 'ng-inline-svg-2';
import {FilterByPipe} from '../../standalone/pipes/filter-by.pipe';
// import {SvgNodeComponent} from './svg-node-component/svg-node.component';
import {
  GlobalruleactionFormBuilderComponent
} from './globalruleaction-form-builder/globalruleaction-form-builder.component';
import {InsparkTabPanelModule} from '../inspark-tab-panel/inspark-tab-panel.module';

@NgModule({
  declarations: [
    StandardFormBuilderComponent,
    StandardFormPanelComponent,
    ExpressionBuilderComponent,
    StandardGroupFormBuilderComponent,
    ModernFormBuilderComponent,
    ExtractFormValuePipe,
    FileuploadFormBuilderComponent,
    FilterInvisiblePipe,
    SelectItemGroupDataPrepPipe,
    OnecolumnFormBulderComponent,
    FormParamValueComponent,
    IconPicklistFormComponent,
    SeparatedBtnFormPanelComponent,
    SimpleFormBuilderComponent,
    GlobalruleactionFormBuilderComponent,
    RuleactionFormBuilderComponent,
    FormExpressionViewerComponent,
    ParsedExpressionBlockComponent,
    MaxCharsPipe,
    ModernFormPanelComponent,
    AttributesListComponent,
    SvgNodeComponent
  ],
  exports: [StandardFormBuilderComponent,
    StandardFormPanelComponent,
    StandardGroupFormBuilderComponent,
    FileuploadFormBuilderComponent,
    OnecolumnFormBulderComponent,
    FormParamValueComponent,
    IconPicklistFormComponent,
    SeparatedBtnFormPanelComponent,
    SimpleFormBuilderComponent,
    GlobalruleactionFormBuilderComponent,
    RuleactionFormBuilderComponent,
    FormExpressionViewerComponent,
    ModernFormBuilderComponent,
    ModernFormPanelComponent,
    AttributesListComponent,
    SvgNodeComponent,
    FilterByPipe,
    InsparkComponentsModule
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    DragDropModule,
    InlineSVGModule,
    FileUploadModule,
    InsparkComponentsModule,
    SharedModule,
    CalendarModule,
    PipesModule,
    TreeTableModule,
    DropdownModule,
    RadioButtonModule,
    InsparkOverlayHlsVideoModule,
    FilterByPipe,
    InsparkTabPanelModule
  ],
  providers: []
})
export class PageStandardFormsModule {
}
